var $237e6ecb0d468883$exports = {};
$237e6ecb0d468883$exports = {
    "help": `\u{30D8}\u{30EB}\u{30D7}`,
    "info": `\u{60C5}\u{5831}`
};


export {$237e6ecb0d468883$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
